import { useIsDesktop } from "./useIsDesktop.js";
import { useIsDesktopExtraLarge } from "./useIsDesktopExtraLarge.js";
import { useIsDesktopLarge } from "./useIsDesktopLarge.js";
import { useIsTablet } from "./useIsTablet.js";
const useCurrentBreakpoint = ()=>{
    const isTablet = useIsTablet();
    const isDesktop = useIsDesktop();
    const isDesktopLarge = useIsDesktopLarge();
    const isDesktopExtraLarge = useIsDesktopExtraLarge();
    if (isDesktopExtraLarge) return 'xl';
    if (isDesktopLarge) return 'lg';
    if (isDesktop) return 'md';
    if (isTablet) return 'sm';
    return 'xs';
};
export { useCurrentBreakpoint };
